import { icon } from '../../icons';
import { i18nService, t, translateEventType, translateTimelineTitle } from '../../services/i18n';
import { type TimelineEventDto } from '../../services/api';

export const EVENT_TYPE_ICONS: Record<string, string> = {
  MoveIn: icon('key', { size: 12 }),
  MoveOut: icon('door-open', { size: 12 }),
  Damage: icon('alert-circle', { size: 12 }),
  Inspection: icon('search', { size: 12 }),
  Indexation: icon('trend-up', { size: 12 }),
  Remark: icon('message-square', { size: 12 }),
};

export const EVENT_TYPE_BADGE: Record<string, string> = {
  MoveIn: 'badge-success',
  MoveOut: 'badge-warning',
  Damage: 'badge-danger',
  Inspection: 'badge-info',
  Indexation: 'badge-info',
  Remark: 'badge-muted',
};

export function esc(str: string): string {
  const el = document.createElement('span');
  el.textContent = str;
  return el.innerHTML;
}

export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return i18nService.formatDate(date, { day: 'numeric', month: 'long', year: 'numeric' });
}

export function filterEvents(events: TimelineEventDto[], startDate: string, endDate: string): TimelineEventDto[] {
  if (!startDate && !endDate) return events;
  return events.filter((event) => {
    if (startDate && event.date < startDate) return false;
    if (endDate && event.date > endDate) return false;
    return true;
  });
}

export function getTimelineTitle(event: Pick<TimelineEventDto, 'title' | 'titleKey'>): string {
  return translateTimelineTitle(event.title, event.titleKey);
}
